/**
 * @generated SignedSource<<4aec93096cfe713d9878e0f49d513cf2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedHeadLinkTags_metadata$data = {
  readonly canonical: string | null;
  readonly disableIndexing: boolean | null;
  readonly next: string | null;
  readonly prev: string | null;
  readonly " $fragmentType": "SharedHeadLinkTags_metadata";
};
export type SharedHeadLinkTags_metadata$key = {
  readonly " $data"?: SharedHeadLinkTags_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedHeadLinkTags_metadata">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedHeadLinkTags_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canonical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "disableIndexing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "next",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prev",
      "storageKey": null
    }
  ],
  "type": "MetaData",
  "abstractKey": null
};

(node as any).hash = "fe44edbfd9fb00feb7d3dea57ccd37d2";

export default node;
